import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: [`color`,`center`,`text`],
  setup(__props) {

const props=__props

const color=computed(()=>{
    return props.color
})


return (_ctx: any,_cache: any) => {
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([color.value,{centerPos:_ctx.center}])
  }, [
    _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
    _renderSlot(_ctx.$slots, "default")
  ], 2)), [
    [_directive_ripple]
  ])
}
}

})